"use client";

import { Card, Col, Row, Typography } from "antd";
import { Fragment, useEffect } from "react";
import Head from "next/head";
import PDFViewer from "@/components/common/PDFViewer";
import MKTScript from "@/components/MKTScript";

const { Title } = Typography;

const DeliveryPolicyPage = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <MKTScript />
      <Head>
        <title>Chính sách giao hàng | {process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}</title>
        <meta
          name="description"
          content={`Chính sách giao hàng của ${process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}`}
        />
      </Head>
      <div className="delivery-policy-container">
        <Row justify="center" style={{ padding: "20px" }}>
          <Col xs={24} sm={22} md={20} lg={18} xl={16}>
            <Card
              variant="borderless"
              style={{
                marginBottom: "2rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              }}
            >
              <Title
                level={1}
                style={{ textAlign: "center", marginBottom: "2rem" }}
              >
                CHÍNH SÁCH GIAO HÀNG
              </Title>

              <PDFViewer
                file="/static/docs/delivery-policy.pdf"
                title="Chính sách giao hàng chi tiết"
                width={800}
                showControls={true}
                showDownload={true}
                className="delivery-policy-pdf"
              />
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx global>{`
        .delivery-policy-container {
          background-color: #f5f5f5;
          min-height: 100vh;
          padding: 2rem 0;
        }

        .delivery-policy-pdf {
          width: 100%;
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .delivery-policy-container {
            padding: 1rem 0;
          }
          
          .delivery-policy-pdf {
            width: 100%;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default DeliveryPolicyPage;